
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import type { RegistrationFormData } from "@/types/auth"
import { UseFormReturn } from "react-hook-form"

interface PersonalInfoFieldsProps {
  form: UseFormReturn<RegistrationFormData>
}

export function PersonalInfoFields({ form }: PersonalInfoFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <FormField
        control={form.control}
        name="firstName"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-sm font-medium text-left block">
              Primeiro Nome
            </FormLabel>
            <FormControl>
              <Input
                placeholder="Seu primeiro nome"
                className="h-11"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="lastName"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-sm font-medium text-left block">
              Sobrenome
            </FormLabel>
            <FormControl>
              <Input
                placeholder="Seu sobrenome"
                className="h-11"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
